<script setup lang="ts">
import { BadgeCustomerStatus } from '@shared/ui/badges'
import { AppText } from '@shared/ui/typography'
import { RowInfo } from '@shared/ui/other'
import { CardAdmin } from '@shared/ui/cards'

import { useSectionCustomerStatuses } from '../model/section-customer-statuses.hook'

defineOptions({
  name: 'SectionCustomerStatuses',
})

const {
  hasDetails,
  refOtpStatus,
  refGeneral,
  refStatus,
  refSources,
} = useSectionCustomerStatuses()
</script>

<template>
  <div
    v-if="hasDetails"
    class="section-customer-statuses"
  >
    <CardAdmin
      title="Statuses & Sources"
      fullwidth
    >
      <div class="section-customer-statuses__rows">
        <RowInfo title="OTP status:">
          <AppText
            name="body1"
            color="emerald-600"
          >
            {{ refOtpStatus }}
          </AppText>
        </RowInfo>
        <RowInfo
          v-for="row in refGeneral"
          :key="row.key"
          :title="row.key"
          :value="row.value"
        />
        <RowInfo title="Status:">
          <BadgeCustomerStatus
            v-if="refStatus"
            :status="refStatus"
          />
        </RowInfo>
        <RowInfo
          v-for="row in refSources"
          :key="row.key"
          :title="row.key"
          :value="row.value"
        />
      </div>
    </CardAdmin>
  </div>
</template>

<style scoped lang="scss" src="./SectionCustomerStatuses.scss" />
